import { PuckCompanyScoreProvider } from "../contexts/PuckCompanyScoreContext";
import { PuckActionPlanProvider } from "../contexts/PuckActionPlanContext";

export type PuckDataProviderProps = {
    children: JSX.Element;
};

export const PuckDataProvider = (props: PuckDataProviderProps) => {
    const { children } = props;
    return (
        <PuckCompanyScoreProvider>
            <PuckActionPlanProvider>{children}</PuckActionPlanProvider>
        </PuckCompanyScoreProvider>
    );
};
